var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c(
        "q-modal",
        {
          staticClass: "sl-modal",
          attrs: {
            value: _vm.open,
            id: "details-modal",
            "no-esc-dismiss": true,
            "no-backdrop-dismiss": true,
            maximized: _vm.maximized,
            "content-css": {
              width: "1200px",
              maxWidth: "100%",
              minHeight: "85vh"
            }
          },
          on: {
            hide: function($event) {
              _vm.onClose()
            }
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c(
                    "q-toolbar-title",
                    [
                      _c("q-icon", { attrs: { name: "fa fa-users" } }),
                      _vm.mode === "add"
                        ? _c("span", [_vm._v("Add Student")])
                        : _vm._e(),
                      _vm.mode === "edit"
                        ? _c("span", [_vm._v("Edit Student Details")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("q-icon", {
                    staticClass: "gt-sm",
                    attrs: { size: "20px", name: "filter_none" },
                    nativeOn: {
                      click: function($event) {
                        _vm.toggleMaximized()
                      }
                    }
                  }),
                  _c("q-icon", {
                    attrs: { name: "clear" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.onClose($event)
                      }
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "sl-row sl-abs" }, [
                _c(
                  "div",
                  { staticClass: "sl-col-3 navigation sl-vp" },
                  [
                    _c(
                      "q-list",
                      { attrs: { highlight: "" } },
                      [
                        _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "general" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("general")
                              }
                            }
                          },
                          [_c("q-item-main", { attrs: { label: "General" } })],
                          1
                        ),
                        _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "addresses" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("addresses")
                              }
                            }
                          },
                          [
                            _c("q-item-main", { attrs: { label: "Addresses" } })
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "documents" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("documents")
                              }
                            }
                          },
                          [
                            _c("q-item-main", { attrs: { label: "Documents" } })
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "classes" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("classes")
                              }
                            }
                          },
                          [_c("q-item-main", { attrs: { label: "Classes" } })],
                          1
                        ),
                        _c(
                          "q-item",
                          {
                            class: { active: _vm.selectedTab === "notes" },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateSelectedTab("notes")
                              }
                            }
                          },
                          [_c("q-item-main", { attrs: { label: "Notes" } })],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "sl-col-9 sl-vp",
                    staticStyle: { "padding-bottom": "60px" },
                    attrs: { id: "class-modal-right" }
                  },
                  [
                    _c(
                      "h5",
                      { staticClass: "text-center" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fa fa-user", color: "primary" }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.studentForm.STUDENT_FIRST_NAME) +
                            " " +
                            _vm._s(_vm.studentForm.STUDENT_LAST_NAME) +
                            "\n            "
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "panel" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fa fa-warning", size: "30px" }
                        }),
                        _vm._v(
                          " You can only edit individual student notes / documents here. Go to the "
                        ),
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.updateSelectedTab("classes")
                              }
                            }
                          },
                          [_vm._v("class")]
                        ),
                        _vm._v(
                          " directly to edit other information.\n            "
                        )
                      ],
                      1
                    ),
                    _vm.selectedTab === "general"
                      ? _c("div", [_c("student-general")], 1)
                      : _vm._e(),
                    _vm.selectedTab === "addresses"
                      ? _c(
                          "div",
                          [
                            _c("student-addresses", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "documents"
                      ? _c("div", [_c("student-documents")], 1)
                      : _vm._e(),
                    _vm.selectedTab === "classes"
                      ? _c("div", [_c("student-classes")], 1)
                      : _vm._e(),
                    _vm.selectedTab === "notes"
                      ? _c("div", [_c("student-notes")], 1)
                      : _vm._e()
                  ]
                )
              ]),
              _c(
                "q-toolbar",
                {
                  staticClass: "sl-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("q-toolbar-title"),
                  _c(
                    "div",
                    { staticClass: "q-px-sm" },
                    [
                      _vm.selectedTab === "documents"
                        ? _c("q-btn", {
                            staticClass: "q-px-md",
                            attrs: {
                              label: "New Upload",
                              color: "blue",
                              icon: "cloud_upload"
                            },
                            on: {
                              click: function($event) {
                                _vm.openUploadModal()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "q-px-sm" },
                    [
                      _vm.mode === "edit"
                        ? _c("q-btn", {
                            staticClass: "q-px-md",
                            attrs: { color: "green", label: "Save" },
                            on: {
                              click: function($event) {
                                _vm.onUpdate()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("q-btn", {
                    attrs: { outline: "", color: "faded", label: "Cancel" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.closeDetails($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }